<div
  class="pr-button-toggle"
  [ngClass]="{ 'is-invalid': derrors && control?.errors }"
>
  <div #indicator class="indicator"></div>
  @for (choice of choices; track choice) {
    <label #labels [class.is-selected]="choice.value == value">
      <input
        [name]="name || formControlName"
        type="radio"
        [value]="choice.value"
        [checked]="choice.value == value"
        (change)="forwardChange($event)"
      />
      <span>{{ choice.label }}</span>
    </label>
  }
</div>
